var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126,
    height: 116,
    viewBox: "0 0 126 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_622",
    "data-name": "Rectangle 622",
    width: 126,
    height: 116,
    transform: "translate(125 258)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(-125 -258)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medicine-rafiki",
    transform: "translate(115 203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-22",
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 146.391,
    height: 0.073,
    transform: "translate(0 95.857)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 6.787,
    height: 0.073,
    transform: "translate(43.929 97.725)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 16.592,
    height: 0.073,
    transform: "translate(117.727 99.294)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 16.592,
    height: 0.073,
    transform: "translate(12.508 99.294)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M96.412,137.8H39.879a1.672,1.672,0,0,1-1.669-1.672V56.657A1.672,1.672,0,0,1,39.879,55H96.412a1.672,1.672,0,0,1,1.672,1.672h0v79.455A1.672,1.672,0,0,1,96.412,137.8ZM39.879,55.059a1.6,1.6,0,0,0-1.6,1.6v79.47a1.6,1.6,0,0,0,1.6,1.6H96.412a1.6,1.6,0,0,0,1.6-1.6V56.657a1.6,1.6,0,0,0-1.6-1.6Z",
    transform: "translate(-27.023 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M312.708,137.8H256.172a1.678,1.678,0,0,1-1.672-1.672V56.657A1.675,1.675,0,0,1,256.172,55h56.536a1.672,1.672,0,0,1,1.666,1.657v79.47a1.669,1.669,0,0,1-1.666,1.672Zm-56.536-82.74a1.6,1.6,0,0,0-1.6,1.6v79.47a1.6,1.6,0,0,0,1.6,1.6h56.536a1.6,1.6,0,0,0,1.6-1.6V56.657a1.6,1.6,0,0,0-1.6-1.6Z",
    transform: "translate(-179.987 -55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 41.215,
    height: 41.215,
    transform: "translate(21.487 54.642)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 37.851,
    height: 41.215,
    transform: "translate(17.538 54.642)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 34.753,
    height: 11.255,
    transform: "translate(19.063 56.873)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 34.753,
    height: 11.255,
    transform: "translate(19.063 69.899)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 34.753,
    height: 11.255,
    transform: "translate(19.063 82.374)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M119.779,263.37a1.23,1.23,0,1,1-1.23-1.23A1.23,1.23,0,0,1,119.779,263.37Z",
    transform: "translate(-82.971 -201.493)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M120.3,349.558a.878.878,0,1,1-.878-.878A.878.878,0,0,1,120.3,349.558Z",
    transform: "translate(-83.834 -262.696)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M120.3,310.258a.878.878,0,1,1-.878-.878A.878.878,0,0,1,120.3,310.258Z",
    transform: "translate(-83.834 -234.902)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 47.917,
    height: 31.582,
    transform: "translate(19.938 4.008)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 47.917,
    height: 31.582,
    transform: "translate(19.013 4.008)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 44.778,
    height: 28.821,
    transform: "translate(20.389 5.513)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M174,75.23l-12.739,28.411H156.03L168.283,75.23Z",
    transform: "translate(-110.347 -69.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M135.695,75.23l-12.938,28.411H116.62L130.146,75.23Z",
    transform: "translate(-82.476 -69.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 48.777,
    height: 1.915,
    transform: "translate(19.013 4.008)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 48.777,
    height: 1.915,
    transform: "translate(19.013 6.418)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 48.777,
    height: 1.915,
    transform: "translate(19.013 8.827)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 48.777,
    height: 1.915,
    transform: "translate(19.013 11.234)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 48.777,
    height: 1.915,
    transform: "translate(19.013 13.644)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 51.278,
    height: 2.383,
    transform: "translate(17.968 35.59)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M335.711,298.58v24.541h-8.672l-.463-2.456h-33.7V298.58Z",
    transform: "translate(-207.13 -227.264)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M315.421,298.58v24.541h-2.732l-.463-2.456H277.86l-.545,2.456H272.59V298.58Z",
    transform: "translate(-192.781 -227.264)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 38.24,
    height: 8.456,
    transform: "translate(81.985 73.037)",
    fill: "none",
    stroke: "#fafafa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 38.24,
    height: 8.54,
    transform: "translate(81.985 83.176)",
    fill: "none",
    stroke: "#fafafa",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 17.195,
    height: 23.256,
    transform: "translate(110.616 2.761)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 17.195,
    height: 23.256,
    transform: "translate(109.755 2.746)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 15.441,
    height: 21.546,
    transform: "translate(110.616 3.619)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 11.802,
    height: 0.504,
    transform: "translate(112.68 20.489)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 11.802,
    height: 0.504,
    transform: "translate(112.68 21.774)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 11.802,
    height: 0.504,
    transform: "translate(112.68 23.059)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M399.056,84.4a4.213,4.213,0,1,1-1.236-2.981A4.213,4.213,0,0,1,399.056,84.4Z",
    transform: "translate(-276.261 -72.815)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 14.683,
    height: 14.683,
    transform: "translate(106.397 32.021)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 14.683,
    height: 14.683,
    transform: "translate(105.141 32.021)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 12.654,
    height: 12.654,
    transform: "translate(106.157 33.037)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 6.711,
    height: 6.711,
    transform: "translate(109.128 36.006)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-22",
    transform: "translate(23.692 164.041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 48.941,
    cy: 3.701,
    rx: 48.941,
    ry: 3.701,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-22",
    transform: "translate(28.979 131.492)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 18.012,
    height: 20.328,
    transform: "translate(0 16.674)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 18.012,
    height: 20.328,
    transform: "translate(9.006 16.674)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 18.012,
    height: 20.328,
    transform: "translate(0 16.674)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 9.024,
    height: 20.328,
    transform: "translate(17.991 16.674)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 2.292,
    cy: 3.958,
    rx: 2.292,
    ry: 3.958,
    transform: "translate(19.838 23.035) rotate(-1.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M172.818,402.044l-.978.023-.038-1.657-.755.018.038,1.657-1.075.026.029,1.291,1.075-.026.041,1.642.755-.018-.038-1.643.978-.023Z",
    transform: "translate(-149.214 -375.772)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 3.648,
    height: 3.648,
    transform: "translate(7.551 16.674)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    width: 3.648,
    height: 13.04,
    transform: "translate(7.551 23.961)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    width: 14.777,
    height: 16.68,
    transform: "translate(9.006)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    width: 14.777,
    height: 16.68,
    transform: "translate(16.396)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    width: 12.472,
    height: 16.68,
    transform: "translate(9.006)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    width: 9.694,
    height: 16.68,
    transform: "translate(21.478)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M186.226,337.188c.044,1.792-.764,3.267-1.8,3.291s-1.915-1.411-1.956-3.2.767-3.276,1.8-3.276S186.185,335.394,186.226,337.188Z",
    transform: "translate(-158.022 -328.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M187.217,339.914l-.8.018-.032-1.361-.621.015.032,1.361-.884.021.026,1.06.881-.02.032,1.35.621-.018-.032-1.347.8-.018Z",
    transform: "translate(-159.751 -332.038)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    width: 2.995,
    height: 16.68,
    transform: "translate(12.206)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-22",
    transform: "translate(45.937 64.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M226.95,236.045s-4.313,20.424-4.685,27.2,1.4,23.8,1.4,23.8l5.51.878,1.051-21.727,2.415-16.563s2.53,13.468,3.619,16.621,6.286,12.3,10.578,19.6l3.689-2.7s-6.895-19.716-8.072-23.566-.381-20.173-4.011-24.807Z",
    transform: "translate(-203.092 -191.464)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M226.95,236.045s-4.313,20.424-4.685,27.2,1.4,23.8,1.4,23.8l5.51.878,1.051-21.727,2.415-16.563s2.53,13.468,3.619,16.621,6.286,12.3,10.578,19.6l3.689-2.7s-6.895-19.716-8.072-23.566-.381-20.173-4.011-24.807Z",
    transform: "translate(-203.092 -191.464)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M234.273,421.384a17.143,17.143,0,0,1-2.884-.457L231.2,418.1,231.12,417l2.928-.258s.05.843.1,1.809C234.209,419.814,234.305,421.287,234.273,421.384Z",
    transform: "translate(-209.39 -320.15)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M234.139,418.549,231.2,418.1,231.12,417l2.928-.258S234.086,417.583,234.139,418.549Z",
    transform: "translate(-209.39 -320.15)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M222.753,428.934l-.117-.161c-.035-.05-.878-1.23-.755-1.809a.389.389,0,0,1,.2-.266.267.267,0,0,1,.275,0c.419.255.4,1.859.4,2.049Zm-.527-2.143a.187.187,0,0,0-.085.023.269.269,0,0,0-.132.179c-.091.4.384,1.171.615,1.528,0-.565-.076-1.555-.337-1.713a.117.117,0,0,0-.062-.018Z",
    transform: "translate(-202.847 -327.165)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M218.934,430.135l-.17-.07c-.182-.073-1.774-.738-1.874-1.309a.337.337,0,0,1,.12-.313.413.413,0,0,1,.363-.1c.644.111,1.44,1.569,1.464,1.631Zm-1.643-1.672a.269.269,0,0,0-.19.079.2.2,0,0,0-.079.193c.064.375,1.06.878,1.61,1.13-.228-.389-.82-1.315-1.282-1.4Z",
    transform: "translate(-199.323 -328.348)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M221.567,430.914l-2.957-.466a.747.747,0,0,0-.527.114,6.183,6.183,0,0,1-2.269.943c-1.265.179-2.389-.07-2.495.293a1.086,1.086,0,0,0,.545,1.227c.416.217,5.51,1.007,7.659,1.335a.75.75,0,0,0,.858-.811l-.184-1.962A.755.755,0,0,0,221.567,430.914Z",
    transform: "translate(-196.777 -329.838)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M224.67,410.98l.463,2.436,6.031.574.179-2.465Z",
    transform: "translate(-204.828 -316.076)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M312.7,402.01a16.967,16.967,0,0,1-2.541,1.438l-1.739-1.912-.911-1,.925-.878,1.2-1.133s.123.141.325.363l1.066,1.2C311.817,400.979,312.66,401.937,312.7,402.01Z",
    transform: "translate(-263.414 -307.264)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M311.026,400.963l-2.606,1.449-.911-1,.925-.878,1.525-.77Z",
    transform: "translate(-263.414 -308.141)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M309.728,415.4l-.152-.07c-.056-.023-1.341-.612-1.464-1.13a.325.325,0,0,1,.082-.293.36.36,0,0,1,.337-.135c.521.085,1.063,1.335,1.124,1.479Zm-1.244-1.5a.234.234,0,0,0-.182.094.2.2,0,0,0-.05.184c.07.328.8.749,1.215.96-.2-.433-.618-1.171-.949-1.236Z",
    transform: "translate(-263.835 -318.047)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M304.974,418.748a1.113,1.113,0,0,1-.747-.19.416.416,0,0,1-.1-.433.585.585,0,0,1,.343-.41c.764-.345,2.471.524,2.544.562l.146.076-.158.047A9.057,9.057,0,0,1,304.974,418.748Zm-.056-.984a.957.957,0,0,0-.392.07.457.457,0,0,0-.266.322.293.293,0,0,0,.059.293c.351.34,1.783.044,2.483-.143A5.767,5.767,0,0,0,304.919,417.764Z",
    transform: "translate(-261.007 -320.782)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M310.342,409.842l-2.606,1.464a.732.732,0,0,0-.343.416,6.148,6.148,0,0,1-1.195,2.146c-.878.928-1.915,1.432-1.771,1.78a1.08,1.08,0,0,0,1.186.624c.46-.088,4.945-2.635,6.834-3.707a.75.75,0,0,0,.167-1.171l-1.361-1.426a.755.755,0,0,0-.911-.126Z",
    transform: "translate(-261.225 -315.202)",
    fill: "#222221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M298.9,395.962l1.877,1.628,5.086-3.3-1.391-2.044Z",
    transform: "translate(-257.325 -302.83)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M256.2,151.8a23.637,23.637,0,0,1,6.734.433c3.221.676-2.518,4.638-2.518,4.638l-1.8,7.2-3.294.029-.4-10.218Z",
    transform: "translate(-226.229 -132.724)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M241.195,152.216l-6.986,11.023.773-11.559a22.721,22.721,0,0,0-3.326.293c-.788.228-1.464,2.067-2.029,4.585s-1.423,8.555-1.423,8.555l-4.014,33.67s13.723,2.928,20.187.653c0,0-2.43-30.241-2.029-32.109s1.7-8.7,1.7-8.7,1.8-3.411,1.016-4.415S241.195,152.216,241.195,152.216Z",
    transform: "translate(-204.489 -132.694)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x2: 0.995,
    y2: 26.719,
    transform: "translate(28.47 40.73)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    width: 25.586,
    height: 18.908,
    transform: "translate(3.404 28.106) rotate(-18.82)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M184.521,150.92,166.4,177.071l-3.4-1.543-6.1-17.895,24.219-8.253Z",
    transform: "translate(-156.9 -131.068)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M184.521,150.92,160.3,159.174l6.1,17.9-3.4-1.543-6.1-17.895,24.219-8.253Z",
    transform: "translate(-156.9 -131.068)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    width: 25.586,
    height: 18.908,
    transform: "translate(3.404 28.106) rotate(-18.82)",
    fill: "#fff",
    opacity: 0.46
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 6.831,
    cy: 6.831,
    r: 6.831,
    transform: "matrix(0.774, -0.633, 0.633, 0.774, 8.503, 31.975)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M213.459,186.834l-2.784.911-.9-2.735-2.152.706.9,2.735-3.062,1,.694,2.129,3.065-1,.887,2.711,2.152-.706-.887-2.711,2.784-.911Z",
    transform: "translate(-191.243 -156.266)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M261,91.608v-4.26a8.5,8.5,0,0,1,9.123,2.187l-2.049,4.134Z",
    transform: "translate(-230.521 -86.834)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_620",
    "data-name": "Rectangle 620",
    width: 0.539,
    height: 1.648,
    transform: "translate(34.43 1.033) rotate(11.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_621",
    "data-name": "Rectangle 621",
    width: 0.539,
    height: 1.648,
    transform: "translate(33.68 1.997) rotate(-78.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M261.064,110.905c-.852,1.227-1.634,1.057-1.634,1.057a4.684,4.684,0,0,1-.987,1.238c-.141,3.827.987,4.86.987,4.86-1.171,1.806-2.617,1.757-4.081,1.23a2.1,2.1,0,0,1-1.54-1.675,1.891,1.891,0,0,0,1.151-2.366,3.074,3.074,0,0,0-.334-.767c-2.486-.682-3.2-3.065-3.033-5.314a12.153,12.153,0,0,1,.99-3.953L254.046,103l5.724,1.171.307,3.033-1.171,2.249C260.971,107.928,261.925,109.664,261.064,110.905Z",
    transform: "translate(-223.852 -98.267)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M259.79,127.215a2.754,2.754,0,0,1-.416-.029.1.1,0,1,1,.035-.2,2.122,2.122,0,0,0,2.093-.829.1.1,0,0,1,.179.1A2.109,2.109,0,0,1,259.79,127.215Z",
    transform: "translate(-229.312 -114.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M257.169,120.818c.061,0,.31-1.868.31-1.868l-1.329,1.6A1.171,1.171,0,0,0,257.169,120.818Z",
    transform: "translate(-227.091 -109.547)",
    fill: "#a02724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M265.385,117.966c-.032.231-.176.4-.319.384s-.234-.225-.2-.457.176-.407.319-.386S265.418,117.732,265.385,117.966Z",
    transform: "translate(-233.25 -108.525)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M255.725,117.093c-.032.231-.176.4-.319.384s-.234-.223-.2-.457.176-.4.319-.384S255.772,116.858,255.725,117.093Z",
    transform: "translate(-226.418 -107.909)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M267.822,113.091a.138.138,0,0,1-.123-.079c-.348-.741-.84-.644-.861-.641a.138.138,0,0,1-.064-.266c.029,0,.726-.164,1.171.791a.138.138,0,0,1-.067.184A.132.132,0,0,1,267.822,113.091Z",
    transform: "translate(-234.539 -104.698)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M253.6,111.93a.132.132,0,0,1-.094-.038.135.135,0,0,1,0-.193,1.744,1.744,0,0,1,1.809-.442.138.138,0,0,1,.079.179.141.141,0,0,1-.182.076,1.479,1.479,0,0,0-1.508.378A.129.129,0,0,1,253.6,111.93Z",
    transform: "translate(-225.196 -104.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M263.308,141.69a2.591,2.591,0,0,1-.934.908,3.074,3.074,0,0,0-.334-.767A3.109,3.109,0,0,0,263.308,141.69Z",
    transform: "translate(-231.257 -125.629)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M258.709,99.525s-4.939,1.32-6.907.621-1.279-3.118-1.013-3.346c.363-.31,1.154.972,1.154.972S251.3,96.4,251.8,96.1s.586,1.757,2.43,1.54,6.956-1.607,7.258,1.607a11.418,11.418,0,0,1-.9,5.639s-.272-1.757-2.448-.36a.745.745,0,0,1,0-1.224C259.4,102.073,258.957,100.459,258.709,99.525Z",
    transform: "translate(-223.063 -93.364)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M276.3,106.052s-.858,2.8.72,2.67.609-3.062.609-3.062Z",
    transform: "translate(-241.176 -100.148)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M260.733,98.513s-1.031-.758-.767-1.309.673.779,2.726.536,4.488-.427,4.939.934-4.1.325-4.1.325l-2.8.6Z",
    transform: "translate(-229.76 -94.073)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M250.237,215.089l-1.982-.559s-2.342-.143-2.538.75-.293,2.433.638,2.556a34.493,34.493,0,0,0,3.83-.059Z",
    transform: "translate(-219.621 -177.137)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M267.286,163.112l3.194-2.852s3.956,8.783,4.178,12.159-2.386,4.892-4.6,5.46-9.536,2.082-9.536,2.082l-.4-4.076s7.8-1.332,10.807-2.711C270.925,173.183,268.222,165.322,267.286,163.112Z",
    transform: "translate(-229.906 -138.762)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M261.48,223.768l7.384-1.578.02,1.113Z",
    transform: "translate(-230.861 -182.56)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M264.5,150.98l.84,2.219a23.806,23.806,0,0,0,3.666-3.341l-1.218-2.029A7.417,7.417,0,0,1,264.5,150.98Z",
    transform: "translate(-232.997 -129.972)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M258.569,150.3a5.753,5.753,0,0,0,.615,2.427l-.916,2.049a4.453,4.453,0,0,1-1.259-3.6Z",
    transform: "translate(-227.681 -131.718)",
    fill: "#fafafa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataDashboard);
export default __webpack_public_path__ + "static/media/nodataDashboard.496c9e6df4e20ca5b1619a1b0da52824.svg";
export { ForwardRef as ReactComponent };